<template>
	<div style="width: 100%;height: calc(100vh - 60px);">
		<PageHeader @back="goback" :content="'显示字段设置'" />
		<div class="sampleBox">
			<div style="font-size: 16px; margin-bottom: 20px;">样本列表未显示字段 (拖动操作)</div>
			<el-card shadow="never" :body-style="{ padding: '20px 20px 0 20px' }">
				<draggable class="hide" :list="allList" group="my-group">
					<div class="hideField" v-for="element in allList" :key="element.chfieldName">{{ element.chfieldName }}</div>
				</draggable>
			</el-card>
			<div class="show">
				<div>
					<div style="font-size: 16px;">样本列表未已示字段 (拖动操作)</div>
					<div class="leftBox">
						<el-row :gutter="20" style="    width: 100%;">
							<el-col :span="12">
								<el-card shadow="never" class="leftBoxL">
									<div class="showBoxText">列表显示字段(限四个)</div>
									<draggable class="showBoxSampleBox" :list="list1" group="my-group">
										<div class="hideField" v-for="element in list1" :key="element.chfieldName">{{ element.chfieldName }}</div>
									</draggable>
								</el-card>
							</el-col>
							<el-col :span="12">
								<el-card shadow="never" class="leftBoxR">
									<div class="showBoxText">详情显示字段</div>
									<draggable class="showBoxSampleBox" :list="list2" group="my-group">
										<div class="hideField" v-for="element in list2" :key="element.chfieldName">{{ element.chfieldName }}</div>
									</draggable>
								</el-card>
							</el-col>
							<!-- <el-col :span="8">
								<el-card shadow="never">
								从不显示
								</el-card>
							</el-col> -->
						</el-row>
						<!-- <div class="leftBoxL">
							<div class="showBoxText">列表显示字段(限四个)</div>
							<draggable class="showBoxSampleBox" :list="list1" group="my-group">
								<div class="hideField" v-for="element in list1" :key="element.chfieldName">{{ element.chfieldName }}</div>
							</draggable>
						</div>
						<div class="leftBoxR">
							<div class="showBoxText">详情显示字段</div>
							<draggable class="showBoxSampleBox" :list="list2" group="my-group">
								<div class="hideField" v-for="element in list2" :key="element.chfieldName">{{ element.chfieldName }}</div>
							</draggable>
						</div> -->
					</div>
				</div>
				<div class="rightBox">
					<div style="font-size: 16px;">详细资料</div>
					<div class="detailsBox">
						<div class="listBox">
							<div class="title">
								<span v-if="list1[0]">{{ list1[0].field1 || list1[0].chfieldName }}</span>
							</div>
							<div class="listBoxTop">
								<span v-if="list1[1]">{{ list1[1].field1 || list1[1].chfieldName }}</span>
								<span v-if="list1[2]">{{ list1[2].field1 || list1[2].chfieldName }}</span>
								<el-button type="primary" size="mini" round>开始调查</el-button>
							</div>
							<div class="listBoxbom">
								<span v-if="list1[3]">{{ list1[3].field1 || list1[3].chfieldName }}</span>
							</div>
						</div>
						<div class="particulars">
							<div class="singleparticulars" v-for="(item, index) in list2" :key="index">{{ item.field1 || item.chfieldName }}</div>
							<!-- <div class="singleparticulars" v-if="list2[0]">{{ list2[0].field1 || list2[0].chfieldName }}</div>
							<div class="singleparticulars" v-if="list2[1]">{{ list2[1].field1 || list2[1].chfieldName }}</div>
							<div class="singleparticulars" v-if="list2[2]">{{ list2[2].field1 || list2[2].chfieldName }}</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="subBtn"><el-button type="primary" size="medium" @click="addSample">保存</el-button></div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		draggable,
		PageHeader
	},
	data() {
		return {
			list1: [],
			list2: [],
			allList: [], //样本列表未显示总字段
			wj_id: ''
		};
	},
	created() {
		this.wj_id = this.$route.query.id;
		this.queryAllFieldName();
	},
	mounted() {},
	methods: {
		addSample() {
			if (this.list1.length > 4) {
				this.$message.warning('请设置显示字段不超过四个');
				return false;
			}
			let detailField = [];
			let detailFieldName = [];
			let listField = [];
			let listFieldName = [];
			this.list1.forEach(item => {
				detailField.push(item.enfieldName);
				detailFieldName.push(item.chfieldName);
			});
			this.list2.forEach(item => {
				listField.push(item.enfieldName);
				listFieldName.push(item.chfieldName);
			});
			let that = this;
			let data = {
				questionnaireId: this.wj_id,
				detailField: detailField,
				detailFieldName: detailFieldName,
				listField: listField,
				listFieldName: listFieldName
			};
			console.log(data);
			let params = {
				that: this,
				url: `${this.$config.service.saveOrUpdate}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadData() {
			let that = this;
			let data = {
				id: this.wj_id
			};
			let params = {
				that: this,
				url: `${this.$config.service.getSample}?id=${this.wj_id}`,
				method: 'GET',
				data: data,
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						let detailField = res.resultBody.detailField.split(',');
						let detailFieldName = res.resultBody.detailFieldName.split(',');
						let listField = res.resultBody.listField.split(',');
						let listFieldName = res.resultBody.listFieldName.split(',');
						let list1 = [];
						let list2 = [];
						detailField.forEach((item, index) => {
							let tempObj = {
								enfieldName: item,
								chfieldName: detailFieldName[index]
							};
							list1.push(tempObj);
						});

						listField.forEach((item, index) => {
							let tempObj = {
								enfieldName: item,
								chfieldName: listFieldName[index]
							};
							list2.push(tempObj);
						});
						let tempAllList = [...list1, ...list2];
						let newArr = that.resArr(that.allList, tempAllList);
						that.allList = newArr;
						that.list1 = list1;
						that.list2 = list2;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		//函数封装
		resArr(arr1, arr2) {
			return arr1.filter(v => arr2.every(val => val.chfieldName != v.chfieldName));
		},
		queryAllFieldName() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.wj_id
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						let list = res.resultBody.questionsFieldMappings;
						list.forEach((item, index) => {
							// if(item.enfieldName == res.resultBody.documents[index])
							console.log(index);
							for (var key in res.resultBody.documents) {
								console.log(key, res.resultBody.documents[key]);
								if (key == item.enfieldName) {
									item.field1 = res.resultBody.documents[key];
								}
							}
						});
						that.allList = list;
						that.loadData();
					} else {
						that.allList = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style lang="scss" scoped>
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}		
.hideField {
	line-height: 32px;
	border-radius: 4px;
	padding: 0 10px;
	border: 1px solid #EBEEF5;
	box-sizing: border-box;
	cursor: all-scroll;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 10px 20px 10px;
	font-size: 14px;
}
.sampleBox {
	width: 1100px;
	margin: 0px auto;
	.hideText {
		margin-bottom: 20px;
	}
	.hide {
		// min-height: 300px;
		// border: 1px solid rgba(187, 187, 187, 0.5);
		// margin-bottom: 20px;
		display: flex;
		flex-wrap: wrap;
		// padding: 20px 20px 0px 20px;
		max-height: 280px;
		overflow-y: auto;
	}

	.show {
		margin-top: 20px;
		min-height: 300px;
		display: flex;
		// justify-content: space-between;
		.leftBox {
			margin-top: 20px;
			height: 300px;
			width: 745px;
			display: flex;
			.hideField {
				line-height: 32px;
				border-radius: 4px;
				padding: 0 10px;
				border: 1px solid #EBEEF5;
				box-sizing: border-box;
				cursor: all-scroll;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 0 10px 10px 10px;
			}
			.showBoxText{
				font-size: 16px;
				margin-bottom: 10px;
			}
			.leftBoxL,
			.leftBoxR {
				height: 400px;
			}
			.showBoxSampleBox {
				height: 325px;
				overflow-y: auto;
			}
		}
		.rightBox {
			flex: 1;
			margin-left: 20px;
			.detailsBox {
				font-size: 14px;
				margin-top: 20px;
				height: 360px;
				border: 1px solid #EBEEF5;
				padding: 20px;
				border-radius: 4px;
				.listBox {
					.listBoxTop {
						display: flex;
						justify-content: space-between;
						align-items: center;
    					font-size: 12px;
						// height: 40px;
						// line-height: 40px;
					}
					.listBoxbom {
    					font-size: 12px;
					}
				}
				.particulars {
					height: 292px;
					margin-top: 20px;
					overflow-y: auto;
					.singleparticulars {
						height: 40px;
						line-height: 40px;
						border-radius: 8px;
						background-color: rgba(242, 242, 242, 1);
						text-align: center;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
}
.subBtn {
	width: 1100px;
	margin: 20px auto;
	text-align: center;
}
</style>
